import api from './axiosApi'

// Types matching backend OpenAPI spec
export interface SeasonRead {
  id: string
  name: string
  icon_id: string | null
  created_by: string
  updated_by: string
  created_at: string // ISO datetime
  updated_at: string // ISO datetime
}

interface PaginatedSeasonsResponse {
  data: SeasonRead[]
  total: number
  skip: number
  limit: number
}

/**
 * Fetch seasons from the API
 * Returns all seasons (up to 1000 - the API max limit)
 */
export async function fetchSeasons(): Promise<SeasonRead[]> {
  const response = await api.get<PaginatedSeasonsResponse>('/seasons', {
    params: { limit: 100 },
  })
  return response.data.data
}
